import styled, { css } from "styled-components";
import { Icon } from "../icons";
import type { IconSize, IconName } from "../icons";
import ButtonWrapper from "./ButtonWrapper";
import type { ButtonProps as AntButtonProps } from "antd/es/button";

interface IconTextButtonProps extends Omit<AntButtonProps, "size"> {
  iconName: IconName;
  size?: IconSize;
  text: string;
  colorScheme?: ColorScheme;
}

type ColorScheme = "primary" | "secondary";

type StyledIconTextButtonProps = {
  $colorScheme: ColorScheme;
} & Omit<IconTextButtonProps, "colorScheme" | "iconName" | "text">;

const IconTextButton = ({
  iconName,
  size = "medium",
  text,
  colorScheme = "secondary",
  ...rest
}: IconTextButtonProps) => {
  return (
    <StyledButton $colorScheme={colorScheme} {...rest}>
      <Icon iconName={iconName} size={size} />
      <p>{text}</p>
    </StyledButton>
  );
};

const colorSchemeStyles = {
  primary: css`
    color: var(--button-primary) !important;

    p {
      color: var(--button-primary);
    }

    &:hover {
      background-color: transparent !important;

      p {
        color: var(--button-primary);
      }

      svg path {
        fill: var(--button-primary) !important;
      }
    }
  `,

  secondary: css`
    color: var(--text-tertiary) !important;

    p {
      color: var(--text-tertiary);
    }

    &:hover {
      background-color: transparent !important;

      p {
        color: var(--primary);
      }

      svg path {
        fill: var(--primary) !important;
      }
    }
  `,
};

const StyledButton = styled(ButtonWrapper)<StyledIconTextButtonProps>`
  display: flex;
  align-items: center;
  gap: var(--gap-0);
  background-color: transparent !important;
  ${({ $colorScheme }) => colorSchemeStyles[$colorScheme]}

  p {
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-small);
    line-height: var(--line-height-small);
  }
`;

export default IconTextButton;
